import { Component, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from './../../../environments/environment';
import { Globals } from './../../globals'
import { CookieService } from "ngx-cookie-service";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-menu',
  templateUrl: 'user-menu.component.html',
  encapsulation: ViewEncapsulation.None
})
export class UserMenuComponent
{
  globals: Globals
  langActual: string;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private translate: TranslateService,
    globals: Globals,
    private cookies: CookieService
  ) {
    this.globals = globals;
    this.matIconRegistry.addSvgIcon(
      "usuario_fondo",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/usuario-fondo.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "cerrar_sesion",
      this.domSanitizer.bypassSecurityTrustResourceUrl("assets/img/cerrar-sesion.svg")
    );
    var lenguaje = this.cookies.get("lenguajeFuncionario");
    if (lenguaje == "") {
      this.translate.setDefaultLang('es');
      this.translate.use('es');
      this.langActual = "es";
      this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
    }
    else {
      if (lenguaje == "es") {
        this.translate.use('es');
        this.langActual = "es";
        this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
        
      } else {
        this.translate.use('en');
        this.langActual = "en";
        this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
      }
    }
    
    
  }

  cerrarsesion() {
    //this.cookies.deleteAll(environment.raiz, environment.dominio)
    this.cookies.delete("tokensessionFuncionario", environment.raiz, environment.dominio)
    window.location.href = environment.redirecturl;
  }

  changeLang() {
    if (this.langActual == "es") {
      this.translate.use('en');
      this.langActual = "en";
      this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
    } else {
      this.translate.use('es');
      this.langActual = "es";
      this.cookies.set("lenguajeFuncionario", this.langActual, 1, environment.raiz, environment.dominio, false, "Lax");
    }
  }
  
}
